import { AppConfigurationVariable as ConfigurationVariable } from 'graphql/models/extended';
import { AppConfigurationVariableValue as ConfigurationVariableValue } from 'graphql/models/extended';
import { ConfigurationBooleanValue } from 'graphql/models/extended';
import { SelectorVariableValue } from 'graphql/models/product-selector.model';

export function noPrintout(
  value: ConfigurationVariable | ConfigurationVariableValue | SelectorVariableValue
): boolean {
  return value?.noPrintout?.valueText === ConfigurationBooleanValue.TRUE;
}
